var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from 'react';
import { Dialog, Grid, Hidden, Slide } from '@material-ui/core';
import { Carousel } from '@thd-olt-component-react/core-ui';
import { Close } from '@one-thd/sui-icons';
import { IconButton } from '@one-thd/sui-atomic-components';
import Spinner from '../../../shared/spinner/spinner';
import { getPreYearData } from '../../../../utils/PerkOptionsUtil';
import { ModelButton, YourOptionTab, ModelOptionBodyTitle, RenderLeftGiftOption, OptionFutureOption, RenderRightRedeemedOption, RenderLeftRedeemedGiftOption, RenderRightRentalOption, OptionClaimedRight, ClaimBefore, ReachedSpendMobileTitle, RenderYourPerkOptionsSubTitle, } from '../commons/PerkOptionsCommons';
import '../YourPerkOptions.scss';
import { accountApi } from '../../../../api/common/account';
import { PerksModal } from '../../shared/PerksModal/PerksModal';
import { InfoPerksContext, PerkProgressContext } from '../../../../contexts';
import { getYourPerkOptions, hasUsedAllPerks } from '../../../Utils';
import { clickCta, setOverlayEvent } from '../../../../utils/analytics';
export var transition = React.forwardRef(function (props, ref) { return React.createElement(Slide, __assign({ direction: "up", ref: ref }, props)); });
var userManagementAnalytics = {
    pushMyAccountButtonEvent: function (str) { return clickCta(str); },
};
var RenderYourChooseOptionTab = function (props) {
    var item = props.item, dragging = props.dragging, propPack = props.propPack;
    var PerkInfo = propPack.PerkInfo, data = propPack.data, handleChangeTab = propPack.handleChangeTab;
    var dataObj = { item: item, dragging: dragging };
    return (React.createElement(YourOptionTab, { data: dataObj, PerkInfo: PerkInfo, stateData: data, handleChangeTab: handleChangeTab }));
};
var PerkOptionsModelButton = function (_a) {
    var propPack = _a.propPack;
    var data = propPack.data, selectedIsDetailsClick = propPack.selectedIsDetailsClick, selectedOption = propPack.selectedOption, handleClose = propPack.handleClose, confirmPerkActivate = propPack.confirmPerkActivate;
    return (React.createElement(ModelButton, { data: data, selectedIsDetailsClick: selectedIsDetailsClick, selectedOption: selectedOption, handleClose: handleClose, confirmPerkActivate: confirmPerkActivate }));
};
var ModelCloseIcon = function (_a) {
    var propPack = _a.propPack;
    var handleClose = propPack.handleClose;
    return React.createElement(IconButton, { icon: Close, color: "danger", onClick: handleClose });
};
var ButtonChoosePerk = function (_a) {
    var propPack = _a.propPack;
    var giftActiveStatus = propPack.giftActiveStatus, optionDollar = propPack.optionDollar, optionPerkLibrary = propPack.optionPerkLibrary, statusUnclaimed = propPack.statusUnclaimed, earned = propPack.earned, isMobile = propPack.isMobile, handleClickOpen = propPack.handleClickOpen, rentalActiveStatus = propPack.rentalActiveStatus, buttonSelectedClass = propPack.buttonSelectedClass;
    var option = giftActiveStatus ? 1 : 2;
    var amount = 0;
    var title = '';
    if (option === 1) {
        amount = optionDollar[0] ? optionDollar[0].amount : 0;
        title = optionDollar[0] ? optionDollar[0].perkTitle : '';
    }
    else if (option === 2) {
        amount = optionPerkLibrary[0] ? optionPerkLibrary[0].amount : 0;
        title = optionPerkLibrary[0] ? optionPerkLibrary[0].perkTitle : '';
    }
    return statusUnclaimed && earned ? (React.createElement(Grid, { className: isMobile ? '' : 'YourPerkOption__titleBox' },
        React.createElement("button", { type: "button", onClick: function () { return handleClickOpen(option, false, amount, title); }, disabled: !rentalActiveStatus && !giftActiveStatus, className: buttonSelectedClass() }, "Choose Perk"))) : null;
};
var ModelHeadingMobile = function (_a) {
    var propPack = _a.propPack;
    var selectedIsDetailsClick = propPack.selectedIsDetailsClick;
    return selectedIsDetailsClick ? (React.createElement(Grid, { className: "mobile-header u__float-clear " },
        React.createElement("span", { className: "row-headerText" }, "Pro Xtra Perk Details"),
        React.createElement(Grid, { item: true, className: "YourPerkOption__modelCloseBox sui-justify-end" },
            React.createElement(ModelCloseIcon, { propPack: propPack })))) : (React.createElement(Grid, { className: " mobile-header u__float-clear " },
        React.createElement("span", { className: "row-headerText" }, "Confirm Pro Xtra Perk Choice"),
        React.createElement(Grid, { item: true, className: "YourPerkOption__modelCloseBox sui-justify-end" },
            React.createElement(ModelCloseIcon, { propPack: propPack }))));
};
var ModelDesktop = function (_a) {
    var propPack = _a.propPack;
    var selectedOption = propPack.selectedOption, optionDollar = propPack.optionDollar, data = propPack.data, optionPerkLibrary = propPack.optionPerkLibrary, PerkInfo = propPack.PerkInfo, isLoading = propPack.isLoading, isOpen = propPack.isOpen, setIsOpen = propPack.setIsOpen, hasError = propPack.hasError, earned = propPack.earned;
    var opt;
    var modalTitle = '';
    if (selectedOption === 1) {
        opt = optionDollar[0];
        if (optionDollar[0]) {
            modalTitle = optionDollar[0].perkTitle;
        }
        else {
            modalTitle = data.item.tierPerks[0].perkTitle;
        }
    }
    else if (selectedOption === 2) {
        opt = optionPerkLibrary[0];
        if (optionPerkLibrary[0]) {
            modalTitle = optionPerkLibrary[0].perkTitle;
        }
        else {
            modalTitle = data.item.tierPerks[0].perkTitle;
        }
    }
    if (opt === undefined && hasUsedAllPerks(PerkInfo)) {
        opt = data.item.tierPerks[0];
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(PerksModal, { currentPerkDetails: opt, title: modalTitle, showFinalWarning: true, showHowTo: false, isLoading: isLoading, showModal: isOpen, setShowModal: setIsOpen, hasError: hasError, isEarned: earned },
            React.createElement(PerkOptionsModelButton, { propPack: propPack }))));
};
var ModelMobile = function (_a) {
    var propPack = _a.propPack;
    var isOpen = propPack.isOpen, isLoading = propPack.isLoading, selectedOption = propPack.selectedOption, selectedAmount = propPack.selectedAmount, selectedIsDetailsClick = propPack.selectedIsDetailsClick, hasError = propPack.hasError, optionPerkLibrary = propPack.optionPerkLibrary, optionDollar = propPack.optionDollar, handleClose = propPack.handleClose, statusUnclaimed = propPack.statusUnclaimed, getDataItem = propPack.getDataItem;
    var modelData = getDataItem();
    return (React.createElement(Dialog, { fullScreen: true, open: isOpen, onClose: handleClose, TransitionComponent: transition, disableEnforceFocus: true },
        React.createElement("div", { className: "YourPerkOption__modalContainer" },
            isLoading && React.createElement(Spinner, { active: isLoading }),
            React.createElement(Grid, { className: "YourPerkOption__modelheadingBox" },
                React.createElement(Grid, { container: true },
                    React.createElement(ModelHeadingMobile, { propPack: propPack })),
                React.createElement(Grid, { container: true, className: "YourPerkOption__modelBody ".concat(isLoading ? 'sui-invisible' : '') },
                    React.createElement(ModelOptionBodyTitle, { option: selectedOption, currentData: modelData, selectedAmount: selectedAmount, selectedIsDetailsClick: selectedIsDetailsClick, hasError: hasError, optionPerkLibrary: optionPerkLibrary, optionDollar: optionDollar })),
                statusUnclaimed && (React.createElement(Grid, { container: true, className: "YourPerkOption__modelButton YourPerkOption__modelStickyFooter ".concat(isLoading ? 'sui-invisible' : '') },
                    React.createElement(PerkOptionsModelButton, { propPack: propPack })))))));
};
var ModelDetails = function (_a) {
    var propPack = _a.propPack;
    var isMobile = propPack.isMobile;
    return (React.createElement(Grid, { item: true, xs: 12 }, isMobile ? (React.createElement(ModelMobile, { propPack: propPack })) : (React.createElement(ModelDesktop, { propPack: propPack }))));
};
var LeftOption = function (_a) {
    var propPack = _a.propPack;
    var isMobile = propPack.isMobile, optionDollar = propPack.optionDollar, PerkInfo = propPack.PerkInfo, activeMap = propPack.activeMap, giftCardClicked = propPack.giftCardClicked, handleClickOpen = propPack.handleClickOpen, getDataItem = propPack.getDataItem;
    var dataItem = getDataItem();
    return (React.createElement(RenderLeftGiftOption, { giftCards: optionDollar, PerkInfo: PerkInfo, currentData: dataItem, giftActive: activeMap.giftActive, giftCardClicked: giftCardClicked, handleClickOpen: handleClickOpen, isMobile: isMobile }));
};
var OptionLeftSection = function (_a) {
    var propPack = _a.propPack;
    var statusRedeemed = propPack.statusRedeemed, statusActive = propPack.statusActive, statusGiftCard = propPack.statusGiftCard, earned = propPack.earned, statusUnclaimed = propPack.statusUnclaimed, currentData = propPack.currentData, optionActiveRedeem = propPack.optionActiveRedeem, currentSpendZero = propPack.currentSpendZero, giftCardClicked = propPack.giftCardClicked, handleClickOpen = propPack.handleClickOpen, freeRentalClicked = propPack.freeRentalClicked, currentTier = propPack.currentTier, nextTier = propPack.nextTier, optionDollar = propPack.optionDollar, statusExpired = propPack.statusExpired, getDataItem = propPack.getDataItem;
    var ActiveRedeemedLibrary = (statusRedeemed || statusActive) && !statusGiftCard;
    var unClaimed = (earned && statusUnclaimed) ||
        currentData.item.tierPerks[0].perkStatus === undefined;
    var optionRedeem = optionActiveRedeem();
    var dataItem = getDataItem();
    if (currentSpendZero && statusUnclaimed) {
        return React.createElement(LeftOption, { propPack: propPack });
    }
    if (optionRedeem) {
        return (React.createElement(RenderLeftRedeemedGiftOption, { currentData: dataItem, giftCardClicked: giftCardClicked, handleClickOpen: handleClickOpen }));
    }
    if (ActiveRedeemedLibrary) {
        return (React.createElement(RenderRightRedeemedOption, { currentData: dataItem, freeRentalClicked: freeRentalClicked, handleClickOpen: handleClickOpen, activeRedeem: ActiveRedeemedLibrary }));
    }
    if (!earned && currentTier) {
        return React.createElement(LeftOption, { propPack: propPack });
    }
    if (!earned && nextTier) {
        return React.createElement(OptionFutureOption, null);
    }
    if (unClaimed && optionDollar && !statusExpired) {
        return React.createElement(LeftOption, { propPack: propPack });
    }
    return React.createElement(React.Fragment, null);
};
var RightOption = function (_a) {
    var propPack = _a.propPack;
    var isMobile = propPack.isMobile, optionPerkLibrary = propPack.optionPerkLibrary, PerkInfo = propPack.PerkInfo, activeMap = propPack.activeMap, freeRentalClicked = propPack.freeRentalClicked, handleClickOpen = propPack.handleClickOpen, getDataItem = propPack.getDataItem;
    var dataItem = getDataItem();
    return (React.createElement(RenderRightRentalOption, { perkLibrary: optionPerkLibrary, PerkInfo: PerkInfo, rentalActive: activeMap.rentalActive, currentData: dataItem, freeRentalClicked: freeRentalClicked, handleClickOpen: handleClickOpen, isMobile: isMobile }));
};
var OptionRightSection = function (_a) {
    var propPack = _a.propPack;
    var statusRedeemed = propPack.statusRedeemed, statusActive = propPack.statusActive, statusExpired = propPack.statusExpired, currentData = propPack.currentData, currentSpendZero = propPack.currentSpendZero, statusUnclaimed = propPack.statusUnclaimed, earned = propPack.earned, currentTier = propPack.currentTier, nextTier = propPack.nextTier, optionPerkLibrary = propPack.optionPerkLibrary, getDataItem = propPack.getDataItem;
    var ActiveRedeemedLibrary = statusRedeemed || statusActive;
    var statusOption = statusExpired ? '' : statusActive || statusRedeemed;
    var statusUndefined = currentData.item.tierPerks[0].perkStatus === undefined;
    var dataItem = getDataItem();
    if (currentSpendZero && statusUnclaimed) {
        return React.createElement(RightOption, { propPack: propPack });
    }
    if (statusOption || ActiveRedeemedLibrary) {
        return React.createElement(OptionClaimedRight, { currentData: dataItem });
    }
    if (!earned && currentTier) {
        return React.createElement(RightOption, { propPack: propPack });
    }
    if (!earned && nextTier) {
        return React.createElement(OptionFutureOption, null);
    }
    if (((earned && statusUnclaimed) || statusUndefined) &&
        optionPerkLibrary &&
        !statusExpired) {
        return React.createElement(RightOption, { propPack: propPack });
    }
    return React.createElement(React.Fragment, null);
};
var RenderOptionBox = function (_a) {
    var propPack = _a.propPack;
    var getDataItem = propPack.getDataItem;
    // Need to handle on whether a tier was selected or not
    // Check data object to confirm if a tier was selected or not?
    var dataItem = getDataItem();
    return (React.createElement(Grid, null,
        React.createElement(Grid, { container: true, className: "YourPerkOption__tileBody" },
            React.createElement(Grid, { item: true, md: 6, lg: 6, xs: 6, sm: 6 },
                React.createElement(OptionLeftSection, { propPack: propPack })),
            React.createElement(Grid, { item: true, md: 6, lg: 6, xs: 6, sm: 6 },
                React.createElement(OptionRightSection, { propPack: propPack }))),
        React.createElement(ButtonChoosePerk, { propPack: propPack }),
        React.createElement(ClaimBefore, { currentData: dataItem })));
};
var RenderDesktop = function (_a) {
    var propPack = _a.propPack;
    var earned = propPack.earned, statusUnclaimed = propPack.statusUnclaimed, PerkInfo = propPack.PerkInfo, data = propPack.data;
    var boxBorder = earned && statusUnclaimed
        ? 'YourPerkOption__activeBorder YourPerkOption__boxHeight'
        : 'YourPerkOption__inActiveBorder YourPerkOption__boxHeightActive';
    return (React.createElement(Grid, { className: boxBorder },
        React.createElement(ReachedSpendMobileTitle, { PerkInfo: PerkInfo, currentData: data }),
        React.createElement(RenderOptionBox, { propPack: propPack })));
};
var RenderMobile = function (_a) {
    var propPack = _a.propPack;
    var statusUnclaimed = propPack.statusUnclaimed, earned = propPack.earned, nextTier = propPack.nextTier, showToggleShowHideLabel = propPack.showToggleShowHideLabel, toggleShowHide = propPack.toggleShowHide, toggle = propPack.toggle, statusExpired = propPack.statusExpired, PerkInfo = propPack.PerkInfo, mobileDataItem = propPack.mobileDataItem;
    var boxBorder;
    if (statusUnclaimed && earned) {
        boxBorder = 'YourPerkOption__boxHeight YourPerkOption__activeBorder';
    }
    else {
        boxBorder = 'YourPerkOption__boxHeight YourPerkOption__inActiveBorder';
    }
    var toggleArrow = !earned && nextTier ? showToggleShowHideLabel : !toggleShowHide;
    return (React.createElement(Grid, { className: boxBorder },
        React.createElement(Grid, { item: true, container: true, xs: 12, sm: 12 },
            React.createElement(Grid, { item: true, xs: 1, sm: 1 },
                React.createElement("button", { type: "button", onClick: toggle, className: (!earned && statusUnclaimed) || statusExpired
                        ? ''
                        : "mobileArrow ".concat(toggleArrow ? ' mobileUpArrow ' : 'mobileDownArrow', " ") })),
            React.createElement(Grid, { item: true, xs: 11, sm: 11 },
                React.createElement(ReachedSpendMobileTitle, { PerkInfo: PerkInfo, currentData: mobileDataItem }))),
        toggleArrow && React.createElement(RenderOptionBox, { propPack: propPack })));
};
var RenderPerkOptions = function (_a) {
    var propPack = _a.propPack, dragging = _a.dragging;
    var statusExpired = propPack.statusExpired, isMobile = propPack.isMobile, isOpen = propPack.isOpen, PerkInfo = propPack.PerkInfo, filteringData = propPack.filteringData;
    return statusExpired && isMobile ? (React.createElement(React.Fragment, null)) : (React.createElement("div", { className: "PerkProgress__PerkOptions" },
        React.createElement(Grid, { className: "options-container" },
            isOpen && React.createElement(ModelDetails, { propPack: propPack }),
            React.createElement(Grid, { item: true, md: 12, lg: 12, xs: 12, sm: 12 },
                React.createElement(Hidden, { smDown: true },
                    React.createElement(RenderYourPerkOptionsSubTitle, { PerkInfo: PerkInfo })),
                React.createElement(Grid, { item: true },
                    React.createElement(Hidden, { smDown: true },
                        React.createElement(Carousel, { fade: true, navigation: true, dotsBelow: true, peek: false, slidesPerView: "auto", slidesPerGroup: 1, breakpoints: {
                                sm: {
                                    slidesPerView: 5,
                                    slidesPerGroup: 2,
                                },
                                md: {
                                    slidesPerView: 5,
                                    slidesPerGroup: 1,
                                },
                                lg: {
                                    slidesPerView: 4,
                                    slidesPerGroup: 1,
                                },
                                xl: {
                                    slidesPerView: 5,
                                    slidesPerGroup: 1,
                                },
                            } }, filteringData.map(function (filteredItem) { return (React.createElement(RenderYourChooseOptionTab, { key: filteredItem.tierId, item: filteredItem, dragging: dragging, propPack: propPack })); }))))),
            isMobile ? (React.createElement(RenderMobile, { propPack: propPack })) : (React.createElement(RenderDesktop, { propPack: propPack })))));
};
export var PerkOptions = function (_a) {
    var PerkInfo = _a.PerkInfo, dragging = _a.dragging, isMobile = _a.isMobile;
    var _b = React.useContext(PerkProgressContext), currentDataIndex = _b.currentDataIndex, filterData = _b.filterData, setActivatedPerks = _b.setActivatedPerks, setFilterData = _b.setFilterData;
    var setPerksInfo = React.useContext(InfoPerksContext).setPerksInfo;
    var _c = useState(0), selectedAmount = _c[0], setSelectedAmount = _c[1];
    var _d = useState(false), hasError = _d[0], setHasError = _d[1];
    var _e = useState(1), selectedOption = _e[0], setSelectedOption = _e[1];
    var _f = useState(false), isLoading = _f[0], setIsLoading = _f[1];
    var _g = useState({
        giftActive: {},
        rentalActive: {},
    }), activeMap = _g[0], setActiveMap = _g[1];
    var getDataItem = React.useCallback(function () {
        return isMobile
            ? { item: filterData[currentDataIndex] }
            : getYourPerkOptions(PerkInfo);
    }, [currentDataIndex]);
    var _h = useState(false), selectedIsDetailsClick = _h[0], setSelectedIsDetailsClick = _h[1];
    var _j = useState(false), toggleShowHide = _j[0], setToggleShowHide = _j[1];
    var _k = useState(false), showToggleShowHideLabel = _k[0], setShowToggleShowHideLabel = _k[1];
    var _l = useState(getDataItem), data = _l[0], setData = _l[1];
    var _m = useState(false), isOpen = _m[0], setIsOpen = _m[1];
    var isDataDifferent = function (obj) { var _a, _b; return ((_a = data === null || data === void 0 ? void 0 : data.item) === null || _a === void 0 ? void 0 : _a.tierId) !== ((_b = obj === null || obj === void 0 ? void 0 : obj.item) === null || _b === void 0 ? void 0 : _b.tierId); };
    React.useEffect(function () {
        if (isMobile && isDataDifferent(getDataItem()))
            setData(function () { return getDataItem(); });
    }, [currentDataIndex]);
    var item = data === null || data === void 0 ? void 0 : data.item;
    var perks = [];
    var optionDollar = item.tierPerks[0].options.filter(function (list) { return list.sequenceNumber === 0; });
    var optionPerkLibrary = item.tierPerks[0].options.filter(function (list) { return list.sequenceNumber !== 0; });
    if (PerkInfo && PerkInfo.program && PerkInfo.program.tiers) {
        perks = PerkInfo.program.tiers;
    }
    var unclaimedPreYearPerks = PerkInfo.previousYearPerks.filter(function (perk) { return perk.perkStatus === 'UNCLAIMED'; });
    var preYearPerk = getPreYearData(unclaimedPreYearPerks);
    var lastPerkItem = PerkInfo.program.tiers.slice(-1).pop().maxThreshold;
    var unclaimedPerkData = perks.filter(function (perk) {
        return perk.tierPerks[0].earned && perk.tierPerks[0].perkStatus === 'UNCLAIMED';
    });
    var currentPerkData = perks.filter(function (perk) {
        return !perk.tierPerks[0].earned && PerkInfo.currentTierId === perk.tierId;
    });
    var nextTierData = perks.filter(function (perk) { return PerkInfo.nextTierId === perk.tierId; });
    var lastTierData = perks.filter(function (perk) { return perk.maxThreshold === lastPerkItem; });
    var tierData = [];
    if (nextTierData.length > 0) {
        tierData = nextTierData;
    }
    else if (unclaimedPerkData.length === 0) {
        tierData = lastTierData;
    }
    var filterData1 = preYearPerk &&
        unclaimedPerkData &&
        currentPerkData &&
        tierData &&
        preYearPerk
            .concat(unclaimedPerkData)
            .concat(currentPerkData)
            .concat(tierData);
    var filteringData = filterData1.filter(function (filteringItem, index) {
        return filterData1.indexOf(filteringItem) === index;
    });
    var earned = item.earned, minThreshold = item.minThreshold, tierPerks = item.tierPerks, tierId = item.tierId;
    var statusActive = tierPerks[0].perkStatus === 'ACTIVE' ||
        tierPerks[0].perkStatus === 'INACTIVE';
    var statusExpired = tierPerks[0].perkStatus === 'EXPIRED';
    var statusRedeemed = tierPerks[0].perkStatus === 'REDEEMED';
    var statusUnclaimed = tierPerks[0].perkStatus === 'UNCLAIMED';
    var statusGiftCard = tierPerks[0].giftCard;
    var nextTier = PerkInfo.nextTierId === tierId;
    var currentTier = PerkInfo.currentTierId === tierId;
    var currentSpendZero = PerkInfo.currentYearSpend === 0 && minThreshold === 0;
    var giftActiveStatus = activeMap.giftActive[tierPerks[0].perkId];
    var rentalActiveStatus = activeMap.rentalActive[tierPerks[0].perkId];
    var handleClickOpen = function (option, isDetailsClick, amount, title) {
        // both of these variables are assigned the same value...
        var proXtraDollars = title;
        var toolRentalText = title;
        setHasError(false);
        setSelectedOption(function () { return option; });
        setSelectedAmount(function () { return amount; });
        setSelectedIsDetailsClick(function () { return isDetailsClick; });
        setIsOpen(function () { return true; });
        if (isDetailsClick) {
            if (item.tierPerks[0].earned === true) {
                setOverlayEvent("perks details: unlocked ".concat(selectedOption === 1
                    ? proXtraDollars.toLowerCase()
                    : toolRentalText.toLowerCase()));
            }
            else {
                setOverlayEvent("perks details: locked ".concat(selectedOption === 1
                    ? proXtraDollars.toLowerCase()
                    : toolRentalText.toLowerCase()));
            }
        }
        else {
            setOverlayEvent('confirm your perk choice');
        }
    };
    var handleClose = function () {
        setIsOpen(function () { return false; });
        setHasError(function () { return false; });
        setSelectedIsDetailsClick(function () { return false; });
    };
    var confirmPerkActivate = function (option) {
        setIsLoading(function () { return true; });
        var activateTierRewardId = '';
        var tierOption = {};
        var isGiftCard = option === 1 ? optionDollar[0].giftCard : optionPerkLibrary[0].giftCard;
        if (option === 1) {
            if (isGiftCard)
                activateTierRewardId = optionDollar[0].tierRewardId;
            tierOption = __assign({}, optionDollar[0]);
        }
        else if (option === 2) {
            activateTierRewardId = optionPerkLibrary[0].tierRewardId;
            tierOption = __assign({}, optionPerkLibrary[0]);
        }
        var activationData = {
            perkId: tierPerks[0].perkId,
            programId: PerkInfo.program.programId,
            tierId: tierId,
            tierRewardId: activateTierRewardId,
        };
        userManagementAnalytics.pushMyAccountButtonEvent("perks: claimed:  ".concat(isGiftCard
            ? optionDollar[0].perkTitle.toLowerCase()
            : optionPerkLibrary[0].perkTitle.toLowerCase()));
        accountApi.choosePerkActivate(activationData).then(function (res) {
            var _a;
            setIsLoading(function () { return false; });
            if (res.type === 'ACTIVE_PERK_SUCCESS') {
                var newData_1 = __assign(__assign({}, item), { tierPerks: [
                        __assign(__assign(__assign({}, item.tierPerks[0]), tierOption), { perkStatus: 'ACTIVE', paymentId: res.paymentId, activationTime: res.activationTime, expirationTime: res.expirationTime }),
                    ] });
                var perkInfo = __assign({}, PerkInfo);
                var perkTiers = (_a = perkInfo === null || perkInfo === void 0 ? void 0 : perkInfo.program) === null || _a === void 0 ? void 0 : _a.tiers;
                var tierIdx = perkTiers.findIndex(function (tier) { return tier.tierId === newData_1.tierId; });
                if (tierIdx > -1) {
                    perkInfo.program.tiers[tierIdx] = newData_1;
                    setPerksInfo(perkInfo);
                }
                var filterDataList_1 = __spreadArray([], filterData, true);
                var dataIndex = filterDataList_1.findIndex(function (tier) { return tier.tierId === newData_1.tierId; });
                if (dataIndex > -1) {
                    filterDataList_1[dataIndex] = newData_1;
                    setFilterData(function () { return filterDataList_1; });
                }
                setData({ item: newData_1 });
                setActivatedPerks({ item: newData_1, currentDataIndex: currentDataIndex });
                sessionStorage.setItem('perkClaimed', 'true');
                handleClose();
                return res;
            }
            if (!res.type || res.type === 'ACTIVE_PERK_FAIL') {
                setHasError(function () { return true; });
            }
            return '';
        });
    };
    var handleChangeTab = function (obj) {
        if (isDataDifferent(obj)) {
            setData(function () { return obj; });
            setSelectedIsDetailsClick(function () { return false; });
            userManagementAnalytics.pushMyAccountButtonEvent("perks: selection drawer");
        }
    };
    var giftCardClicked = function (perkTierId) {
        setActiveMap(function () {
            var _a, _b;
            return ({
                giftActive: (_a = {}, _a[perkTierId] = !activeMap.giftActive[perkTierId], _a),
                rentalActive: (_b = {}, _b[perkTierId] = false, _b),
            });
        });
    };
    var freeRentalClicked = function (perkTierId) {
        setActiveMap(function () {
            var _a, _b;
            return ({
                giftActive: (_a = {}, _a[perkTierId] = false, _a),
                rentalActive: (_b = {}, _b[perkTierId] = !activeMap.rentalActive[perkTierId], _b),
            });
        });
    };
    var toggle = function () {
        if (!earned && nextTier) {
            setShowToggleShowHideLabel(function () { return !showToggleShowHideLabel; });
        }
        else {
            setToggleShowHide(function () { return !toggleShowHide; });
        }
    };
    var buttonSelectedClass = function () {
        var rentalAct = rentalActiveStatus;
        var giftAct = giftActiveStatus;
        var active;
        if (rentalAct) {
            active = 'btn buttonSelected';
        }
        else if (giftAct) {
            active = 'btn buttonSelected ';
        }
        else {
            active = 'btn buttonUnSelected';
        }
        return active;
    };
    var optionActiveRedeem = function () {
        return statusExpired
            ? ''
            : (statusActive || statusRedeemed) && statusGiftCard;
    };
    var propPack = {
        // Functions
        setSelectedAmount: setSelectedAmount,
        setHasError: setHasError,
        setSelectedOption: setSelectedOption,
        setIsLoading: setIsLoading,
        setActiveMap: setActiveMap,
        setSelectedIsDetailsClick: setSelectedIsDetailsClick,
        setToggleShowHide: setToggleShowHide,
        setShowToggleShowHideLabel: setShowToggleShowHideLabel,
        setData: setData,
        setIsOpen: setIsOpen,
        handleClickOpen: handleClickOpen,
        handleClose: handleClose,
        confirmPerkActivate: confirmPerkActivate,
        handleChangeTab: handleChangeTab,
        giftCardClicked: giftCardClicked,
        freeRentalClicked: freeRentalClicked,
        toggle: toggle,
        buttonSelectedClass: buttonSelectedClass,
        optionActiveRedeem: optionActiveRedeem,
        getDataItem: function () { return data; },
        // Variables
        PerkInfo: PerkInfo,
        isMobile: isMobile,
        currentData: data,
        currentDataIndex: currentDataIndex,
        filterData: filterData,
        selectedAmount: selectedAmount,
        hasError: hasError,
        selectedOption: selectedOption,
        isLoading: isLoading,
        activeMap: activeMap,
        selectedIsDetailsClick: selectedIsDetailsClick,
        toggleShowHide: toggleShowHide,
        showToggleShowHideLabel: showToggleShowHideLabel,
        data: data,
        isOpen: isOpen,
        mobileDataItem: data,
        item: item,
        perks: perks,
        optionDollar: optionDollar,
        optionPerkLibrary: optionPerkLibrary,
        unclaimedPreYearPerks: unclaimedPreYearPerks,
        preYearPerk: preYearPerk,
        lastPerkItem: lastPerkItem,
        unclaimedPerkData: unclaimedPerkData,
        currentPerkData: currentPerkData,
        nextTierData: nextTierData,
        lastTierData: lastTierData,
        tierData: tierData,
        filterData1: filterData1,
        filteringData: filteringData,
        earned: earned,
        minThreshold: minThreshold,
        tierPerks: tierPerks,
        tierId: tierId,
        statusActive: statusActive,
        statusExpired: statusExpired,
        statusRedeemed: statusRedeemed,
        statusUnclaimed: statusUnclaimed,
        statusGiftCard: statusGiftCard,
        nextTier: nextTier,
        currentTier: currentTier,
        currentSpendZero: currentSpendZero,
        giftActiveStatus: giftActiveStatus,
        rentalActiveStatus: rentalActiveStatus,
    };
    return React.createElement(RenderPerkOptions, { propPack: propPack, dragging: dragging });
};
PerkOptions.displayName = 'PerkOptions';
